import { cn } from "../../../lib/utils.js";

export function AttachmentCardShell({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      className={cn(
        "my-1 flex w-full max-w-full min-w-0 items-start gap-2.5 rounded-lg border border-line/80 bg-surface/80 px-2.5 py-2",
        className,
      )}
    >
      {children}
    </div>
  );
}
